import React from "react";
import { Fade } from "react-reveal";

const Education = () => {
  return (
    <div
      style={{ background: "#0b0b0d", color: "white" }}
      className="main-div"
      id="education"
    >
      <Fade left>
        <section className="div-1 education">
          <h1 className="heading">Education</h1>
          <article className="education-card">
            <div className="education-heading">
              <h2>SRMS College of Engineering and Technology</h2>
              <p>2016 – 2020</p>
            </div>
            <p className="education-detail">
              B.Tech in Computer Science
              <span> · CGPA 7.6 / 10</span>
            </p>
            <p className="education-place">Bareilly, India</p>
          </article>
        </section>
      </Fade>
    </div>
  );
};

export default Education;
